import React from "react";
import { Dialog, Button, Flex, Loader } from "@fluentui/react-northstar";

const ConfirmDialog = ({
  open,
  onConfirm,
  onCancel,
  title,
  content,
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
}) => {
  return (
    <Dialog
      open={open}
      onCancel={onCancel}
      header={title}
      styles={{
        maxWidth: "450px",
      }}
      content={
        <Flex column gap="gap.small">
          {content}
        </Flex>
      }
      confirmButton={{
        content: confirmText,
        "data-cy": "confirm-dialog-confirm-btn",
        onClick: onConfirm,
        disabled: loading,
        loading: loading,
      }}
      cancelButton={{
        content: cancelText,
        "data-cy": "confirm-dialog-cancel-btn",
        onClick: onCancel,
        disabled: loading,
      }}
    />
  );
};

export default ConfirmDialog;
